declare global {
  interface Window {
    __ENV__?: {
      VITE_API_BASE_URL?: string;
    };
  }
}

function normalizeBaseUrl(value: string): string {
  const trimmed = value.trim();
  return trimmed.replace(/\/+$/, '');
}

export function getApiBaseUrl(): string {
  const fromWindow =
    typeof window !== 'undefined' ? window.__ENV__?.VITE_API_BASE_URL : undefined;

  if (typeof fromWindow === 'string' && fromWindow.trim() !== '') {
    return normalizeBaseUrl(fromWindow);
  }

  const fromVite = import.meta.env.VITE_API_BASE_URL;
  if (typeof fromVite === 'string' && fromVite.trim() !== '') {
    return normalizeBaseUrl(fromVite);
  }

  // Safe default for production (expects reverse-proxy to the API)
  return '/api';
}

export const API_BASE_URL = getApiBaseUrl();

